@if(formId() && publicApiKey) {
<iframe [src]="iframeSrc" width="100%" height="max-content" style="border: none; overflow: hidden;" loading="lazy">
</iframe>
}